import { Model, Factory, belongsTo } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import {
  rand,
  randPhrase,
  randBoolean,
  randPhoneNumber,
  randPastDate,
  randRecentDate,
  randChanceBoolean,
} from '@ngneat/falso'

import type { PhoneData } from '@/models/client.js'
import type { MockServer } from './server.js'

export const model = (Model as ModelDefinition<PhoneData>).extend({
  client: belongsTo('client'),
})

export const factory = Factory.extend<PhoneData>({
  type_code() {
    return rand(['PERSONAL_PHONE', 'WORK_PHONE'])
  },
  phone_number() {
    return randPhoneNumber({ countryCode: 'UK' })
  },
  description() {
    return randPhrase({ maxCharCount: 80 })
  },
  preferred_reminders() {
    return randBoolean()
  },
  is_secondary_owners_phone_number() {
    return randChanceBoolean({ chanceTrue: 0.3 })
  },
  created() {
    return randPastDate().toISOString()
  },
  modified() {
    return randRecentDate().toISOString()
  },
})

export function routes(server: MockServer) {
  server.resource('phone', { path: '/phonenumbers' })
}
